import CustomDomainListsDashboard from "./CustomDomainListsDashboard";

export default CustomDomainListsDashboard;
